import { useMemo } from 'react'
import { css } from '@emotion/react'
import { Table, Row, ITableProps } from 'common-components'
import { PresetTag } from '@components/display/preset-tag'
import { ColumnsType } from 'antd/lib/table'
import { ProjectType } from '@types'
import { TProjectState } from '@definitions'
import { useTranslation } from '@hooks'

type ProjectsTablePropsType = {
  projectsAvailable: ProjectType[]
  tableProps?: Partial<Omit<ITableProps<ProjectType>, 'data'>>
}

const ProjectsTable = ({ projectsAvailable, tableProps = {} }: ProjectsTablePropsType) => {
  const { translate } = useTranslation()

  const tableColumns: ColumnsType<ProjectType> = useMemo(
    () => [
      {
        title: 'Nom',
        dataIndex: 'name',
        key: 'name',
        render: (name) => <Row align={'middle'}>{name}</Row>,
      },
      {
        title: 'Statut',
        dataIndex: 'state',
        key: 'state',
        render: (status: TProjectState) => (
          <Row
            align={'middle'}
            css={css`
              width: 300px;
            `}
          >
            <PresetTag preset={'project-state'} state={status} withDot>
              {translate(`common.states.projectState.${status}`)}
            </PresetTag>
          </Row>
        ),
      },
      // TODO HIDE not remove
      // {
      //   title: 'Compétence',
      //   dataIndex: 'competence',
      //   key: 'competence',
      //   render: (competence) => (
      //     <Row align={'middle'}>
      //       <Tag color={colors.gray700} style={{ fontWeight: 500 }}>
      //         <Icon icon={'Type01'} color={colors.gray500} width={16} height={16} />
      //         {competence}
      //       </Tag>
      //     </Row>
      //   ),
      // },
      // {
      // 	title: "Segments",
      // 	dataIndex: "segments",
      // 	key: "segments",
      // 	render: (segments) => (
      // 		<Row align={"middle"}>
      // 			<IconAvatarGroup
      // 				avatars={segments.map((segment) => {
      // 					return {
      // 						size: "md",
      // 						icon: "Scale02",
      // 						iconColor: colors.success500,
      // 						borderColor: colors.white,
      // 						iconBackground: colors.success300,
      // 					};
      // 				})}
      // 				maxCount={4}
      // 			/>
      // 		</Row>
      // 	),
      // },
      // TODO HIDE not remove
      // {
      //   title: 'Manager',
      //   dataIndex: 'manager',
      //   key: 'manager',
      //   render: (manager) => (
      //     <Row
      //       align={'middle'}
      //       css={css`
      //         gap: 10px;
      //       `}
      //     >
      //       <Avatar size='md' />
      //       <Text>{manager}</Text>
      //     </Row>
      //   ),
      // },
      // TODO HIDE not remove
      // {
      //   title: 'Durée',
      //   dataIndex: 'duration',
      //   key: 'duration',
      //   render: (duration) => (
      //     <Row align={'middle'}>
      //       <Icon icon={'ClockStopwatch'} color={colors.gray600} />
      //       <Text
      //         css={css`
      //           color: ${colors.gray600};
      //         `}
      //       >
      //         {duration}
      //       </Text>
      //     </Row>
      //   ),
      // },
    ],
    [],
  )

  return <Table<ProjectType> data={projectsAvailable} columns={tableColumns} {...tableProps} />
}

export default ProjectsTable
